<template>
  <div class="circle">
    <span class="initials">{{ userInitials() }}</span>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    contact: Object
  },
  data() {
    return {}
  },
  methods: {
    userInitials() {
      if (this.contact.firstname && this.contact.lastname) {
        return this.contact.firstname.charAt(0) + this.contact.lastname.charAt(0)
      } else if (this.contact.firstname) {
        return this.contact.firstname.charAt(0)
      } else if (this.contact.lastname) {
        return this.contact.lastname.charAt(0)
      } else if (this.contact.company.email) {
        return this.contact.company.email.charAt(0)
      } else {
        return '?'
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.circle
  background-color: $paper
  border-radius: 50%
  height: 64px
  text-align: center
  width: 64px
  display: inline-block

  .initials
    font-size: 32px
    font-weight: $font-semi-bold
    color: $ink
    line-height: 64px
    position: relative
    text-transform: uppercase
</style>



// WEBPACK FOOTER //
// ContactInitials.vue?9fa4d70c